export default "__VITE_ASSET__BcPJsObl__"